var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatSmile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M17.56 22.38a10 10 0 0 1-2.091-1.102c-1.22.494-2.553.766-3.947.766C5.71 22.044 1 17.333 1 11.522S5.71 1 11.522 1c5.81 0 10.522 4.71 10.522 10.522 0 2.18-.664 4.207-1.8 5.887-.073 1.39.657 2.645 1.414 3.756.664.973.497 1.757-.74 1.827-.554.031-1.753-.004-3.359-.613",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#3863F0",
  d: "M8.174 12.956a.968.968 0 0 0-.928 1.189c.42 1.68 2.156 2.638 3.798 2.638 1.707 0 3.302-.968 3.797-2.64a.967.967 0 0 0-.928-1.187zM13.913 10.565a1.435 1.435 0 1 0 0-2.87 1.435 1.435 0 0 0 0 2.87M9.609 9.13a1.435 1.435 0 1 1-2.87 0 1.435 1.435 0 0 1 2.87 0"
})));
export default SvgChatSmile;